export const HOLIDAY_SETTINGS_PATH = "/settings-menu/holiday-settings";
